import Api from "../api/api";

export default async (id) => {
  const { data } = await Api.post(`loan-post/delete/${id}`);
  return data;
};
